var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { today as $14e0f24ef4ac5c92$export$d0bdf45af03a6ea3, getLocalTimeZone as $14e0f24ef4ac5c92$export$aa8b41735afcabd2 } from "../../../node_modules/.pnpm/@internationalized_date@3.8.1/node_modules/@internationalized/date/dist/queries.js";
function headingYearsText(placeholderModelValue) {
  const placeholder = placeholderModelValue ?? $14e0f24ef4ac5c92$export$d0bdf45af03a6ea3($14e0f24ef4ac5c92$export$aa8b41735afcabd2()), startYear = Math.floor(placeholder.year / 10) * 10;
  return `${startYear} - ${startYear + 9}`;
}
__name(headingYearsText, "headingYearsText");
export {
  headingYearsText
};
//# sourceMappingURL=utils.js.map
